export const HMkReleaseValues = {
  receipt: '',
  difficulties: '',
  swallowing: '',
  oralTest: '',
  intervention: '',
  statusChange: '',
  recommendation: '',
};
